import L, { Icon, LatLngExpression, Marker } from 'leaflet';

export class OpenStreetMap {
    public map: L.Map;

    constructor() {
        const coords: LatLngExpression = [47.13241528364815, 7.2490168265073125];
        const popupHTML = document.getElementById('map-popup').innerHTML;

        this.map = L.map('map', {}).setView(coords, 17);

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(this.map);

        const markerIcon: Icon = L.icon({
            iconUrl: `${window.baseUrl}assets/img/map_marker.svg`,
            iconSize: [24, 32],
            popupAnchor: [-155, 164],
        });

        const marker: Marker = L.marker(
            coords,
            {
                icon: markerIcon,
            },
        ).addTo(this.map);

        marker.bindPopup(popupHTML);
    }
}

if (document.getElementById('map')) {
    const map = new OpenStreetMap();
}
